const SCROLL_SPEED = 300;

const getElementToScroll = (element: Element) => {
  const scrollElement = element.parentElement?.parentElement?.querySelector('[drag-to-scroll]');
  if (!scrollElement) {
    throw new Error("Can not find element to scroll. This is a bug.");
  }
  return scrollElement;
}

const scrollLeft = (element: Element) => {
  const scrollElement = getElementToScroll(element);
  scrollElement.scrollBy({
    top: 0,
    left: SCROLL_SPEED * -1,
    behavior: 'smooth'
  });
}

const scrollRight = (element: Element) => {
  const scrollElement = getElementToScroll(element);
  scrollElement.scrollBy({
    top: 0,
    left: SCROLL_SPEED,
    behavior: 'smooth'
  });
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[scroll-left]').forEach(element => {
    element.addEventListener('click', () => scrollLeft(
      element as HTMLElement
    ));
  });

  document.querySelectorAll('[scroll-right]').forEach(element => {
    element.addEventListener('click', () => scrollRight(
      element as HTMLElement
    ));
  });
});
